<template>
  <div class="card">
    <h6>YOUR CURRENT ENERGY SUPPLY</h6>
    <h4>How do you pay for your {{ quote.compareFuel === 'gasElectricity' ? 'gas & electricity' : quote.compareFuel }}?
    </h4>

    <div class="row">
      <div class="col-xs-6" :class="{ 'col-md-3': showPrepayment != false, 'col-md-4': showPrepayment == false }"
        v-if="!showPrepayment">
        <radio-button v-model="quote.currentPayMethod" value="monthlyDirectDebit" @change="onChoose()"
          :error="$v.currentPayMethod.$error">Monthly Direct Debit</radio-button>
      </div>

      <div class="col-xs-6" :class="{ 'col-md-3': showPrepayment != false, 'col-md-4': showPrepayment == false }"
        v-if="!showPrepayment">
        <radio-button v-model="quote.currentPayMethod" value="quarterlyDirectDebit" @change="onChoose()"
          :error="$v.currentPayMethod.$error">Quarterly Direct Debit</radio-button>
      </div>

      <div class="col-xs-6" :class="{ 'col-md-3': showPrepayment != false, 'col-md-4': showPrepayment == false }"
        v-if="!showPrepayment">
        <radio-button v-model="quote.currentPayMethod" value="cashOrCheque" @change="onChoose()"
          :error="$v.currentPayMethod.$error">Cash & Cheque</radio-button>
      </div>

      <div class="col-xs-6 col-md-3" v-if="showPrepayment != false">
        <radio-button v-model="quote.currentPayMethod" value="prePaymentMeter" @change="onChoose()"
          :error="$v.currentPayMethod.$error">Prepayment</radio-button>
      </div>
    </div>
  </div>
</template>

<script>
import RadioButton from '../../../../base/components/forms/RadioButton';

import { mapState, mapActions } from 'vuex';

export default {
  name: 'PaymentType',
  props: {
    $v: Object
  },
  computed: {
    ...mapState({
      quote: ({ quote }) => quote,
      showPrepayment: ({ quote }) => {
        const address = quote.address.parts;
        if (!address) return false;

        const gasdetails = address.gasdetails.find(({ isDomestic }) => isDomestic) || {};
        const elecdetails = address.elecdetails.find(({ isDomestic }) => isDomestic) || {};

        if (quote.compareFuel == 'electricity') {
          return elecdetails.isPrepayment;
        }

        if (quote.compareFuel == 'gas') {
          return gasdetails.isPrepayment;
        }

        return elecdetails.isPrepayment && gasdetails.isPrepayment;
      }
    })
  },
  methods: {
    ...mapActions({
      getSuppliers: 'lookups/getSuppliers'
    }),
    async onChoose() {
      this.$v.currentPayMethod.$touch();

      if (this.$v.currentPayMethod.$invalid) return;

      this.quote.newTariffPaymentMethod = this.quote.currentPayMethod == 'prePaymentMeter' ? 'prePaymentMeter' : 'monthlyDirectDebit';

      this.$store.dispatch('tracing/addAction', { name: 'Page', value: 'Payment Type' });
      this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Next' });
      this.getSuppliers(this.quote.compareFuel);
      await this.$store.dispatch('tracing/saveActions');
    }
  },
  components: {
    RadioButton
  }
};
</script>

<style lang="scss"></style>
